import { useEffect } from "react";

declare global {
  interface Window {
    lucide?: { createIcons: () => void };
  }
}

/** Lucide icon by name. Renders an <i data-lucide="..."> that Lucide swaps to SVG. */
export function Icon({ name, size = 16 }: { name: string; size?: number }) {
  return <i data-lucide={name} style={{ width: size, height: size }} />;
}

/** Mount once per screen/render to (re)swap newly-rendered <i data-lucide> tags. */
export function useLucideIcons(deps: unknown[] = []) {
  useEffect(() => {
    let id: ReturnType<typeof setTimeout>;
    function attempt() {
      if (window.lucide) {
        window.lucide.createIcons();
      } else {
        // CDN not ready yet — keep retrying every 150 ms until it loads
        id = setTimeout(attempt, 150);
      }
    }
    attempt();
    return () => clearTimeout(id);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
